import type { PracticeStep } from '../content'
import type { PracticeFixture, PracticeSession } from './engine'

/** Where a step's link goes: a recording's own page (`po0`) or a dashboard path. */
export function stepHref(step: PracticeStep, fixture: PracticeFixture | null | undefined): string | null {
  if (!step.link) return null
  if (step.link.startsWith('/')) return step.link
  return fixture?.links[step.link] ?? null
}

function pageMatches(target: string, fixture: PracticeFixture | null | undefined, pathname: string) {
  const href = target.startsWith('/') ? target : fixture?.links[target]
  if (!href) return false
  // "/purchase-orders/" means any PO; "/purchase-orders" means the list itself.
  return href.endsWith('/') ? pathname.startsWith(href) && pathname.length > href.length : pathname === href
}

/** Whether the trainee has done what a step asks, from where they are and what they did. */
export function stepDone(
  step: PracticeStep,
  session: PracticeSession,
  fixture: PracticeFixture | null | undefined,
  pathname: string,
): boolean {
  const done = step.done
  if (!done) return false
  if ('visit' in done) return pageMatches(done.visit, fixture, pathname)
  if ('stage' in done) return session.stage >= done.stage
  if ('write' in done) return session.writes > (session.stepWrites ?? 0)
  return false
}
